export default class LocalStorageHelper {
  /**
   * Sets the item in local storage.
   * @param {any} key The key.
   * @param {any} value The value.
   */
  static setItem(key: any, value: any) {
    localStorage.setItem(key, value);
  }

  /**
   * Gets the item from local storage.
   * @param {any} key The key.
   * @returns {any} The item.
   */
  static getItem(key: any) {
    return localStorage.getItem(key);
  }

  /**
   * Removes the item from local storage.
   * @param {any} key The key.
   */
  static removeItem(key: any) {
    localStorage.removeItem(key);
  }

  /**
   * Clears the local storage.
   */
  static clear() {
    localStorage.clear();
  }
}